module.exports = __webpack_public_path__ + "static/media/berka-logo.ced83932.png";